import { render, staticRenderFns } from "./ShareCard.vue?vue&type=template&id=2446df6e&scoped=true"
import script from "./ShareCard.vue?vue&type=script&lang=js"
export * from "./ShareCard.vue?vue&type=script&lang=js"
import style0 from "./ShareCard.vue?vue&type=style&index=0&id=2446df6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2446df6e",
  null
  
)

export default component.exports